import lisalefteye from "../../../image/originals/hollywoodicons/lisalefteye.webp"; 
import ItemNoSize from "../ItemNoSize";

const Shop = () => {
  const items = [
    {
      id: "90_base",
      name: "Left Eye Print",
      image: lisalefteye, // Main image without .webp
      price: "empty for now",
      thumbnails: [lisalefteye], // Other images (if available)
      description: 'Roughly 20" x 20" Museum Rag Paper.',
      projectUrl: "/LeftEyePrint",
      sizes: ["blank"],
    },
  ];

  return <ItemNoSize items={items} />;
};

export default Shop;
